import { Box, BoxProps } from "@mui/material";
import React from "react";

export const PageContainer = (props: BoxProps) => (
    <Box display="flex" sx={{ width: "100%", marginTop: "-120px" }}>
        {props.children}
    </Box>
);
